import initCardsSection from "../Components/Sections/AdvantageCardsSection";
import "Styles/Pages/ScenarioModelerLP.scss";

initCardsSection();